import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=020b77a3&"
import script from "../services.js?vue&type=script&lang=js&"
export * from "../services.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports